export const systemActivitiesState = {
    name: 'app.system.activities',
    url: '/activities',
    component: 'system'
};
